import ProofOfMortgageSvg from '@assets/images/svg/proof-of-mortgage.svg';
import React from 'react';
import { View } from 'react-native';

/** Intrinsic Figma artboard 19×24 */
const ASPECT = 19 / 24;

export interface ProofOfMortgageIconProps {
  size?: number;
  color?: string;
}

export function ProofOfMortgageIcon({
  size = 24,
  color = '#1A1A1A',
}: Readonly<ProofOfMortgageIconProps>) {
  const height = size;
  const width = Math.round(size * ASPECT);

  return (
    <View
      style={{
        width,
        height,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <ProofOfMortgageSvg width={width} height={height} color={color} />
    </View>
  );
}

export default ProofOfMortgageIcon;
